import { snackbar } from 'src/components/common/snackbar/Snackbar';

export const handleThunkError = (
	error: unknown,
	fallbackMessage = 'Something went wrong',
): IErrorResponse => {
	const err = (error as { response?: { data?: IErrorResponse } })?.response
		?.data || {
		description: fallbackMessage,
		code: 0,
		reason: 'unknown_error',
	};

	if (err?.description) {
		snackbar(err.description, 'error');
	} else if (error instanceof Error) {
		snackbar(error.message, 'error');
	} else {
		snackbar('Something went wrong. Please try again.', 'error');
	}

	return err;
};
